import React, { Component } from 'react';
import { Modal, Button } from '@mui/material';

import './../../styles/inbox/imageModal.css';

class AutoIncrModal extends Component<any, any> {
  wrapperRef: any;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: any) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.closeModal();
    }
  };

  render() {
    const { open, message, closeModal } = this.props;
    return (
      <Modal open={open}>
        <div id="image-preview-modal-wrapper">
          <div
            className="image-preview-modal-container auto-incr-modal-container"
            ref={(node) => (this.wrapperRef = node)}
          >
            <div className="image-preview-modal-header">
              <p>Alert</p>
              <i
                className="far fa-times-circle close-button"
                onClick={closeModal}
              />
            </div>
            <div className="image-preview-modal-body">
              <p>{message}</p>
              <div className="auto-incr-wrapper ">
                <Button
                  className="auto-incr-close-btn"
                  onClick={() => this.props.closeModal()}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default AutoIncrModal;
